// extracted by mini-css-extract-plugin
export var container = "_i4-1";
export var cornerButtonContainer = "_i4-6";
export var disabled = "_i4-2";
export var dragActive = "_i4-3";
export var fileContainer = "_i4-5";
export var hiddenInput = "_i4-4";
export var widthContainer = "_i4-0";